export * from './badge-status-detalhe-conferencia-de-fatura.pipe';
